import { type User, UserSchema } from '@scoring/types';
import { produce } from 'immer';
import z from 'zod';
import { put } from '../../queries';
import { queryKeys } from '../../queries/queryKeys';
import { useApiMutation } from '../../queries/useApiMutation';
import { setQueryDataSafe } from '../../utils/queryUtilities';

export const UpdateUserRequestSchema = UserSchema.omit({
    profilePictureImageId: true,
    roles: true,
    email: true,
}).required({
    id: true,
});

export type UpdateUserRequest = z.infer<typeof UpdateUserRequestSchema>;

export const useUpdateUserMutation = () => {
    const mutation = useApiMutation<{ user: UpdateUserRequest }>({
        mutationFn: ({ user }) => put(`users/${user.id}`, user),
        onManualCacheUpdate: (queryClient, _response, args) => {
            setQueryDataSafe<User[]>(queryClient, queryKeys.users.list(), (previous) =>
                produce(previous, (draft) => {
                    const index = draft.findIndex((u) => u.id === args.user.id);
                    if (index !== -1) draft[index] = { ...draft[index], ...args.user };
                })
            );
        },
    });

    return mutation;
};
